// extracted by mini-css-extract-plugin
export default {"wrapper":"settlementItem_wrapper__az9jE","container":"settlementItem_container__6BZ3j","checkmark":"settlementItem_checkmark__eo9sj"};